export const OPEN_OBJECT_SELECT_POPOVER_ACTION = 'DM.OPEN_OBJECT_SELECT_POPOVER_ACTION';
export const CLOSE_OBJECT_SELECT_POPOVER_ACTION = 'DM.CLOSE_OBJECT_SELECT_POPOVER_ACTION';
export const CHANGE_OBJECT_SELECT_POPOVER_LOADING_STATE_ACTION =
	'DM.CHANGE_OBJECT_SELECT_POPOVER_LOADING_STATE_ACTION';
export const OBJECT_SELECT_ON_ACTION_RECEIVED_TRANSACTION =
	'DM.OBJECT_SELECT_ON_ACTION_RECEIVED_TRANSACTION';
export const SET_OBJECT_SELECT_POPOVER_CONTENT_ACTION =
	'DM.SET_OBJECT_SELECT_POPOVER_CONTENT_ACTION';
export const LOAD_MORE_OBJECT_SELECT_FOLDERS_TRANSACTION =
	'DM.LOAD_MORE_OBJECT_SELECT_FOLDERS_TRANSACTION';
export const SELECT_POPOVER_SEARCH_ACTION = 'DM.SELECT_POPOVER_SEARCH_ACTION';
